import React from "react";
import Menu from "../Menu";
import Footer from "../footer";
import MetaTags from "react-meta-tags";
import ReactGA from "react-ga";

export default function info() {
  /////////////////////
  /////////////////////
  ///////////////////
  return (
    <div>
      <MetaTags>
        <title>Как оплатить | Оплата кредита онлайн в Украине ➣ Просто Гроші</title>
        <meta
          name="description"
          content="Как оплатить кредит онлайн| Займы до 10000 грн онлайн на карту ⭐ наличными ✨ быстро ⏰ без отказа ✅ Просто Гроші"
        />
      </MetaTags>
      <Menu />
      <div className="main-block">
        <div className="main-block-info">
          <div className="main-block-info-left">
            <h1>Як оплатити</h1>
          </div>
          <div className="main-block-info-right">
            <p className="howgetlist">
              <span>1)</span>Простий спосіб погасити кредит - оплатити онлайн на сайті через особистий кабінет. Не треба витрачати час на поїздку, можна сплатити з дому або з роботи. Не важливо використовувати ту банківську картку, на яку видано кредит. Підійде будь-яка картка, де достатня сума на момент оплати.
            </p>
            <p className="howgetlist">
              <span>2)</span>Ви можете оплатити кредит у будь-якому відділенні банку або через термінал. Процедура проста. Треба вибрати потрібну опцію та дотримуватися вказівок на екрані. Тільки треба пам'ятати, що в цьому випадку оплата може пройти не одразу, а протягом кількох днів. Тому краще робити переклад заздалегідь і потім упевнитися про отримання.
            </p>
            <p className="howgetlist">
              <span>3)</span>Звернувшись до одного з відділень у Києві чи іншому місті, обравши найближче чи зручне за маршрутом.
            </p>
            <p className="howgetdop">
              Якщо обставини у Вашому житті змінилися, і немає можливості вчасно сплатити всю суму заборгованості, ми надаємо комфортний вихід. Ви сплачуєте відсотки за кредит, та продовжує термін кредитування.
            </p>
          </div>
        </div>
      </div>
      <Footer />
      {ReactGA.pageview("/oplata")}
    </div>
  );
}



// WEBPACK FOOTER //
// src/pages/howPay.js